import { OfferService } from "../../../offers/offer_service.js";
import { showRewarded } from "../../../ads/rewarded.js";
import { adoptEconomyFromPlayer } from "../../../api/player_sync.js";
import type { PlayerDto } from "../../../api/dto/player.dto.js";
import type { ChainStepContext } from "../../../offers/offer_service.js";
import { isPurchaseErrorReported } from "../../../offers/purchase_failure.js";
import { crashCapture } from "../../../crash/crash_reporter.js";

export type ChainOfferStepResult = 'claimed' | 'ad_refused' | 'ad_unavailable' | 'failed';

/** Store cards open IAP; free and rewarded cards are claimed explicitly. */
export async function requestChainOfferStep( offer_id: string, step_id: string, type: 'paid' | 'free' | 'rewarded', context?: ChainStepContext ): Promise<ChainOfferStepResult>
{
  try
  {
    if ( type === 'free' ) adoptPlayer( await OfferService.claimChainOfferFreeStep( offer_id, step_id, context ) );
    else if ( type === 'rewarded' )
    {
      const placement = context?.placement ?? 'chain_offer';
      const watched = await showRewarded( placement );
      await OfferService.trackRewardedAdOutcome( offer_id, watched, { placement, chain_step_id: step_id, ...( context?.placement_id ? { placement_id: context.placement_id } : {} ) } );
      if ( !watched.rewarded ) return watched.shown ? 'ad_refused' : 'ad_unavailable';
      adoptPlayer( await OfferService.claimChainOfferRewardedStep( offer_id, step_id, watched.ad_id, context ) );
    }
    else adoptPlayer( await OfferService.purchaseChainOffer( offer_id, step_id, context ) );
    return 'claimed';
  }
  catch ( error )
  {
    console.warn( '[Chain offer] step claim failed', error );
    if ( !isPurchaseErrorReported( error ) )
      crashCapture( error, { phase: 'chain_offer_step', offer_id, step_id, type } );
    return 'failed';
  }
}

function adoptPlayer( response: { player?: PlayerDto } ): void
{
  if ( response.player )
    adoptEconomyFromPlayer( response.player );
}
